// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://your-backend-api-url.onrender.com'
    : 'http://localhost:3001');

// Brand Configuration
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'lokss2';

// Branch Configuration
export const BRANCH_ID = process.env.REACT_APP_BRANCH_ID ? parseInt(process.env.REACT_APP_BRANCH_ID) : null;

// Sanitize and validate brand display name to prevent XSS
// React escapes JSX automatically, but this adds an extra layer of protection
const sanitizeDisplayName = (name) => {
  if (!name || typeof name !== 'string') {
    return 'Lokss2'; // Default fallback
  }
  // Remove any potentially dangerous characters and limit length
  // Only allow alphanumeric, spaces, hyphens, and basic punctuation
  return name
    .replace(/[<>]/g, '') // Remove < and > to prevent HTML injection
    .trim()
    .substring(0, 50); // Limit to 50 characters
};

export const BRAND_DISPLAY_NAME = sanitizeDisplayName(process.env.REACT_APP_BRAND_DISPLAY_NAME) || 'Lokss2';


export const API_ENDPOINTS = {
  PAGE_VISUALS: `${API_BASE_URL}/api/page-visuals`,
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/auth/login`,

  // Analytics endpoints
  ANALYTICS_SUMMARY: `${API_BASE_URL}/api/analytics/summary`,
  ANALYTICS_TOTALS: `${API_BASE_URL}/api/analytics/totals`,
  ANALYTICS_MONTHLY: `${API_BASE_URL}/api/analytics/monthly`,
  ANALYTICS_WEEKLY: `${API_BASE_URL}/api/analytics/weekly`,
  ANALYTICS_PLATFORMS: `${API_BASE_URL}/api/analytics/platforms`,
  ANALYTICS_RECENT: `${API_BASE_URL}/api/analytics/recent`,
  ANALYTICS_PLATFORM_DETAILS: `${API_BASE_URL}/api/analytics/platform-details`,

  // Brands endpoint
  BRANDS: `${API_BASE_URL}/api/brands`,

  // Branches endpoint
  BRANCHES: `${API_BASE_URL}/api/branches`,

  // Profile endpoints
  PROFILE: (userId) => `${API_BASE_URL}/api/profile/${userId}`,
  UPDATE_PROFILE: (userId) => `${API_BASE_URL}/api/profile/${userId}`,
  UPDATE_PASSWORD: (userId) => `${API_BASE_URL}/api/profile/${userId}/password`,

  // Users management endpoints
  USERS: `${API_BASE_URL}/api/users`,
  USER_BY_ID: (userId) => `${API_BASE_URL}/api/users/${userId}`,
  ROLES: `${API_BASE_URL}/api/roles`,


  // Store Images endpoints
  STORE_IMAGES: `${API_BASE_URL}/api/store-images`,
  UPLOAD_TO_R2: `${API_BASE_URL}/api/upload-to-r2`,

  // Brand-specific R2 upload endpoints
  UPLOAD_XHS_TO_R2: `${API_BASE_URL}/api/upload-xhs-to-r2`,
  UPLOAD_IG_TO_R2: `${API_BASE_URL}/api/upload-ig-to-r2`,
  UPLOAD_STORE_TO_R2: `${API_BASE_URL}/api/upload-store-to-r2`,

  // IG Images endpoints
  IG_IMAGES: `${API_BASE_URL}/api/ig-images`,

  // Automotive model registry (stored by businesses.id)
  VEHICLE_MODELS: `${API_BASE_URL}/api/vehicle-models`,

  // Banner Images endpoints
  BANNER_IMAGES: `${API_BASE_URL}/api/banner-images`,

  // Lucky Draw endpoints
  LUCKY_DRAW_PRIZES: `${API_BASE_URL}/api/lucky-draw-prizes`,
  LUCKY_DRAW_LIVE_EVENT: `${API_BASE_URL}/api/lucky-draw-live-event`,
  LUCKY_DRAW_MEMBERS: `${API_BASE_URL}/api/lucky-draw-members`,
  MEMBERS: `${API_BASE_URL}/api/members`,

  // AI Generation endpoints
  GENERATE_XHS_CONTENT: `${API_BASE_URL}/api/generate-xhs-content`,
  GENERATE_AI_IMAGE: `${API_BASE_URL}/api/generate-ai-image`,
  GENERATE_XHS_AI_IMAGE: `${API_BASE_URL}/api/generate-xhs-ai-image`,
  GENERATE_CONTENT: `${API_BASE_URL}/api/generate-xhs-content`, // Generic endpoint for all platforms

  // Platform Content endpoints
  GOOGLE_CONTENT: `${API_BASE_URL}/api/google-content`,
  FACEBOOK_CONTENT: `${API_BASE_URL}/api/facebook-content`,
  LEMON8_CONTENT: `${API_BASE_URL}/api/lemon8-content`,
  XHS_CONTENT: `${API_BASE_URL}/api/xhs-content`,
  PLATFORM_CONTENT: `${API_BASE_URL}/api/platform-content`,

  // Categories endpoint
  CATEGORIES: `${API_BASE_URL}/api/categories`,

  // Quota endpoints
  QUOTA: `${API_BASE_URL}/api/quota`,
  QUOTA_BY_PLATFORM: (platform) => `${API_BASE_URL}/api/quota/${platform}`,

  // Input History endpoint
  INPUT_HISTORY: `${API_BASE_URL}/api/input-history`,

  // Health check
  HEALTH: `${API_BASE_URL}/api/health`
};

// Brand information
export const BRAND_CONFIG = {
  name: BRAND_NAME,
  displayName: BRAND_DISPLAY_NAME
};

// Utility function to add brand parameter to API requests
export const addBrandParam = (url, brand = BRAND_NAME) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}brand=${brand}`;
};

// Get current brand name
export const getCurrentBrand = () => BRAND_NAME;

export default API_BASE_URL;
